import {
    get_datiUserInfo,
    update_profilo,
    cambia_password,
    genera_embed_token_mio,
    revoca_embed_token_mio,
} from "@/api/api.user.js";

const user = {
    namespaced: true,

    state: {
        user: '',
        role: '',
        mail: '',
        displayName: '',
        menu: [],
        embedToken: null,
    },

    mutations: {
        SET_USER: (state, user) => {

            state.user = user.username
            state.role = user.role
            state.menu = user.menu
            state.mail = user.eMail
            state.displayName = user.displayName
            state.embedToken = user.embedToken
        },
    },

    actions: {

        userInfo({
            commit
        }) {

            return new Promise((resolve, reject) => {

                get_datiUserInfo().then(resp => {

                    commit("SET_USER", resp.data)

                    resolve(resp)

                }).catch(err => {

                    reject(err)
                })
            })

        },

        // Aggiorna email/nome visualizzato, poi ricarica userInfo per tenere lo
        // state coerente (stesso pattern usato altrove: dispatch che si appoggia
        // sulla action già esistente invece di duplicare la logica di commit).
        aggiornaProfilo({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                update_profilo(dati).then(resp => {
                    dispatch("userInfo").then(() => resolve(resp)).catch(() => resolve(resp))
                }).catch(err => reject(err))
            })
        },

        cambiaPassword(_context, dati) {
            return new Promise((resolve, reject) => {
                cambia_password(dati).then(resp => resolve(resp)).catch(err => reject(err))
            })
        },

        // Self-service: come aggiornaProfilo, ricarica userInfo dopo la chiamata così
        // lo stato riflette subito il nuovo embedToken.
        async generaEmbedTokenMio({ dispatch }) {
            const resp = await genera_embed_token_mio()
            await dispatch("userInfo")
            return resp
        },

        async revocaEmbedTokenMio({ dispatch }) {
            const resp = await revoca_embed_token_mio()
            await dispatch("userInfo")
            return resp
        },

    },

    getters: {
        getRole: state => state.role,
        getEmbedToken: state => state.embedToken,

        getTitolo: state => link => {

            let itemFind = state.menu.find(x => x.Link === link);
            if (itemFind)
                return itemFind.Text + '|' + itemFind.Img;

            return ""
        },

        getNome: state => {
            return state.user
        },
        getMail: state => {
            return state.mail
        },
        getDisplayName: state => {
            return state.displayName
        },
    }
}


export default user